export default __webpack_public_path__ + "static/media/union-pay.0b1e26bd.svg";